// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockTitle_container__5JZBm"};